/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
} from './DayOfWeek';
import type { ScheduledDowntimeKind } from './ScheduledDowntimeKind';
import {
    ScheduledDowntimeKindFromJSON,
    ScheduledDowntimeKindFromJSONTyped,
    ScheduledDowntimeKindToJSON,
} from './ScheduledDowntimeKind';

/**
 * 
 * @export
 * @interface ScheduledDowntime
 */
export interface ScheduledDowntime {
    /**
     * 
     * @type {string}
     * @memberof ScheduledDowntime
     */
    reason: string;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledDowntime
     */
    endsAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ScheduledDowntime
     */
    startsAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ScheduledDowntime
     */
    endTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScheduledDowntime
     */
    startTime?: string | null;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof ScheduledDowntime
     */
    daysOfWeek?: Array<DayOfWeek> | null;
    /**
     * 
     * @type {ScheduledDowntimeKind}
     * @memberof ScheduledDowntime
     */
    kind: ScheduledDowntimeKind;
    /**
     * 
     * @type {string}
     * @memberof ScheduledDowntime
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduledDowntime
     */
    id: string;
}



/**
 * Check if a given object implements the ScheduledDowntime interface.
 */
export function instanceOfScheduledDowntime(value: object): value is ScheduledDowntime {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ScheduledDowntimeFromJSON(json: any): ScheduledDowntime {
    return ScheduledDowntimeFromJSONTyped(json, false);
}

export function ScheduledDowntimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledDowntime {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'endsAt': json['endsAt'] == null ? undefined : (new Date(json['endsAt'])),
        'startsAt': json['startsAt'] == null ? undefined : (new Date(json['startsAt'])),
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'daysOfWeek': json['daysOfWeek'] == null ? undefined : ((json['daysOfWeek'] as Array<any>).map(DayOfWeekFromJSON)),
        'kind': ScheduledDowntimeKindFromJSON(json['kind']),
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function ScheduledDowntimeToJSON(value?: ScheduledDowntime | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reason': value['reason'],
        'endsAt': value['endsAt'] == null ? undefined : ((value['endsAt'] as any).toISOString()),
        'startsAt': value['startsAt'] == null ? undefined : ((value['startsAt'] as any).toISOString()),
        'endTime': value['endTime'],
        'startTime': value['startTime'],
        'daysOfWeek': value['daysOfWeek'] == null ? undefined : ((value['daysOfWeek'] as Array<any>).map(DayOfWeekToJSON)),
        'kind': ScheduledDowntimeKindToJSON(value['kind']),
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

